
<template>
  <div
    id="labAnalysisId"
  >
    <v-card
      minHeight="116"
      hover
      tile
    >
      <v-container>
        <v-row noGutters>
          <v-col cols="5">
            <v-list-item threeLine>
              <v-list-item-content>
                <v-list-item-title class="headline">
                  {{ analysis.clientInfo.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="7">
            <v-subheader class="subtitle-2">
              {{ $t('dashboard.labProgress.sampleType') }}
            </v-subheader>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-progress-linear
      v-model="randomInt"
      color="deep-orange darken-2"
    />
  </div>
</template>
<script>
export default {
    name: 'LabAnalysis',
    props: {
        analysis: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            randomInt: this.$utils.getRandomInt(),
        };
    },
};
</script>
